
import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

import Vue2Filters from "vue2-filters";

Vue.use(Vue2Filters);

//import "normalize.css"; // Note this

// Import Bootstrap and BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import "@fontsource/rubik";
import "@fontsource/rubik/500.css";
import "@fontsource/rubik/700.css";
import "@fontsource/rubik/900.css";

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

import GameDisplay from "./views/GameDisplay.vue";
import TitleScreen from "./views/TitleScreen.vue";
import SelectAvatar from "./views/SelectAvatar.vue";
import CoinFlip from "./views/CoinFlip.vue";
import HowToPlay from "./views/HowToPlay.vue";
import InfoScreen from "./views/InfoScreen.vue";

import AudioClip from "./components/AudioClip.vue";
import BGItem from "./components/BGItem.vue";
import GameModal from "./components/GameModal.vue";
import PlayerAvatarContainer from "./components/PlayerAvatarContainer.vue";

import Axios from "axios";
import csv from "csvtojson";

import Analytics from "analytics";
import googleAnalytics from "@analytics/google-analytics";
import axios from "axios";
import analyticsPost from "../../niwa_firebase_temp/functions/src/analyticspost";

const analytics = Analytics({
  app: "NIWA_MyCoastalFutures_Test",
  plugins: [
    googleAnalytics({
      measurementIds: ["G-P5PMVC7VQD"],
    }),
  ],
});

const scriptURL =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vQP2EHHfZz4sjiJf9gKY3gnrqhJxQfMLuNqHAfR4Wu5nfDBZVbG4Fu-Q-DnQCqwVsz_-wxYefHUuvgP/pub?output=csv";

enum States {
  Title = 0,
  TitleReady = 1,
  SelectAvatar = 2,
  CoinFlip = 3,
  Game = 4,
  HowToPlay = 5,
  InfoScreen = 6,
}

export enum MusicTypes {
  None = -1,
  Ambient = 0,
  LowStorm = 1,
  HighStorm = 2,
  Cyclone = 3,
}

export enum PopUps {
  None = 0,
  InfoScreen = 1,
  Resources = 2,
  Feedback = 3,
}

class AppData {
  States = States;
  State: States = States.Title;
  PopUps = PopUps;
  PopUp: PopUps = PopUps.None;
  Dictionary: { [id: string]: string } | null = null;
  px_ratio = 0;
  ImageDictionary: { [id: string]: HTMLImageElement } = {};
  SelectedAvatar = 8;
  SeaLevelRise = 1;
  MusicType = MusicTypes.None;
  MusicKey = 0;
  Muted = false;
  clickCount = 0;
  transitionCount = 0;
  powerupCount = 0;
  popCount = 0;
  IsPortrait = false;
  oldWidth = 0;
  oldHeight = 0;
  isTransitioning = false;
}

class AvatarData {
  id: number;
  fill: string;
  scale: number;

  constructor(id: number, fill: string, scale: number) {
    this.id = id;
    this.fill = fill;
    this.scale = scale;
  }
}

export const avatars: AvatarData[] = [];
avatars.push(new AvatarData(0, "#ff00ff", 0.8305035971223022));
avatars.push(new AvatarData(1, "#b53d30", 0.732589928057554));
avatars.push(new AvatarData(2, "#70c4c7", 0.8305035971223022));
avatars.push(new AvatarData(3, "#57b8d6", 0.8305035971223022));
avatars.push(new AvatarData(4, "#b0d4c2", 0.8305035971223022));
avatars.push(new AvatarData(5, "#e29a00", 0.6690647482014388));
avatars.push(new AvatarData(6, "#9acbee", 0.8305035971223022));
avatars.push(new AvatarData(7, "#ebd46b", 0.8305035971223022));
avatars.push(new AvatarData(8, "#2e78ad", 0.8305035971223022));

interface DownloadedData {
  UniqueID: string;
  Script: string;
}

export const data = new AppData();

export function GameplayDecisionEvent(
  round: number,
  house: number,
  decision: string,
  seaLevelRise: number
) {
  const postObj:analyticsPost = {
    host: window.location.hostname,
    round,
    house,
    decision,
    highSeaLevelRise: seaLevelRise > 1,
  };
  analytics.track("Gameplay_Decision", postObj);
  axios.post(
    "https://us-central1-niwa-temp.cloudfunctions.net/API/analytics",
    postObj
  );
}

function AddImageToDictionary(key: string) {
  const image = new Image();
  image.src = process.env.BASE_URL + key + ".gif?" + Date.now();
  data.ImageDictionary[key] = image;
}

export function GetDynamicImage(key: string): string {
  const oldUrl = data.ImageDictionary[key].src;
  AddImageToDictionary(key);
  return oldUrl;
}

export function HasT(key: string): boolean {
  if (!data.Dictionary) {
    return false;
  }

  return !data.Dictionary[key];
}

export function T(key: string): string {
  key = key.toLowerCase();
  if (!data.Dictionary) {
    return "";
  }

  if (!data.Dictionary[key]) {
    return "Invalid key: " + key;
  }

  return data.Dictionary[key];
}

export function Delay(time: number): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    try {
      setTimeout(resolve, time);
    } catch (err) {
      reject(err);
    }
  });
}

export default Vue.extend({
  name: "App",
  data() {
    return data;
  },
  mixins: [Vue2Filters.mixin],
  components: {
    GameDisplay,
    TitleScreen,
    SelectAvatar,
    CoinFlip,
    BGItem,
    HowToPlay,
    InfoScreen,
    GameModal,
    PlayerAvatarContainer,
    AudioClip,
  },
  mounted() {
    //Track the page view
    analytics.page();

    AddImageToDictionary("dice-1");
    AddImageToDictionary("dice-2");
    AddImageToDictionary("dice-4");
    AddImageToDictionary("coin-1");
    AddImageToDictionary("coin-2");

    AddImageToDictionary("coin-2");
    AddImageToDictionary("coin-2");
    AddImageToDictionary("coin-2");
    AddImageToDictionary("coin-2");

    AddImageToDictionary("sign_storm_pulsating_infinite");
    AddImageToDictionary("sign_highsurge_growing");
    AddImageToDictionary("sign_highsurge_pulsating_infinite");
    AddImageToDictionary("sign_lowsurge_growing");
    AddImageToDictionary("sign_lowsurge_pulsating_infinite");
    AddImageToDictionary("sign_storm_growing");

    AddImageToDictionary("calendar");

    this.px_ratio =
      window.devicePixelRatio ||
      window.screen.availWidth / document.documentElement.clientWidth;
    //    window.addEventListener("resize", this.resized);
    window.addEventListener("click", this.onClick);

    requestAnimationFrame(this.resized);

    this.resized();

    Axios.get<string>(scriptURL)
      .then((result) => {
        return csv().fromString(result.data);
      })
      .then((values: DownloadedData[]) => {
        this.Dictionary = {};
        for (const keyPair of values) {
          this.Dictionary[keyPair.UniqueID.toLowerCase()] = keyPair.Script;
        }

        return Delay(1000);
      })
      .then(() => {
        if (this.State < States.TitleReady) {
          this.State = States.TitleReady;
        }
      })
      .catch(() => {
        alert("Unable to download script, please refresh the page");
      });
  },
  unmounted() {
    //    window.removeEventListener("resize", this.resized);
    window.removeEventListener("click", this.onClick);
  },
  computed: {
    MusicSource: {
      cache: false,
      get(): string {
        return this.GetMusicBase(this.MusicType);
      },
    },
  },
  methods: {
    T,
    StartGame(): void {
      this.transitionCount++;
      this.State = States.Game;
      this.MusicType = MusicTypes.Ambient;
      this.MusicKey++;
    },
    RestartGame(): void {
      this.transitionCount++;
      this.State = States.TitleReady;
      this.MusicType = MusicTypes.None;
      this.MusicKey++;
    },
    GetAudio(value: string): string {
      return process.env.BASE_URL + value + ".mp3";
    },
    GetMusicBase(value: number): string {
      switch (value) {
        case MusicTypes.Ambient:
          return "ambience";
        case MusicTypes.LowStorm:
          return "low";
        case MusicTypes.HighStorm:
          return "high";
        case MusicTypes.Cyclone:
          return "cyclone";
        default:
          return "";
      }
    },
    GetMusic(value: number): string {
      return process.env.BASE_URL + this.GetMusicBase(value) + ".mp3";
    },
    HowToPlay() {
      this.transitionCount++;
      this.SelectedAvatar = 8;
      this.State = States.HowToPlay;
    },
    SelectAvatar() {
      this.transitionCount++;
      this.SelectedAvatar = 0;
      this.State = States.SelectAvatar;
    },
    clickedAvatar(id: number): void {
      this.SelectedAvatar = id;
    },
    landscapeMode(): void {
      Promise.resolve()
        .then(() => {
          // eslint-disable-next-line
          const element = document.documentElement as any;

          if (element.requestFullscreen) {
            return element.requestFullscreen();
          } else if (element.mozRequestFullScreen) {
            return element.mozRequestFullScreen();
          } else if (element.webkitRequestFullScreen) {
            return element.webkitRequestFullScreen();
          }
        })
        .then(() => {
          return screen.orientation.lock("landscape");
        });
    },
    resized(): void {
      requestAnimationFrame(this.resized);

      const gameWindow = document.getElementById("window");

      const newPx_ratio =
        window.devicePixelRatio || window.screen.availWidth / window.innerWidth;

      let zoomScale = newPx_ratio / this.px_ratio;

      let scale = window.innerHeight / 1025;
      const newTransform = "scale(" + scale * zoomScale + ")";
      let newWidth = "";

      if (window.innerWidth > window.innerHeight) {
        newWidth = window.innerWidth / scale + "px";
      } else {
        const adjustedHeight = window.innerHeight / scale;
        newWidth = adjustedHeight * (1366 / 1024) + "px";
      }

      gameWindow.style.transform = newTransform;
      gameWindow.style.width = newWidth;
    },
  },
});
